<template>
  <div class="flex flex-col md:flex-row gap-2 md:gap-3">
    <div
      v-if="displayTitle"
      class="flex items-center shrink-0 px-1 md:px-0 gap-2"
    >
      <Icon name="chevron-down" class="fg-quaternary" />
      <span class="text-primary text-style-xl md:text-style-sm font-semibold">
        {{ title }}
        <span v-if="!maxSmall">:</span>
      </span>
    </div>
    <div class="flex flex-wrap gap-1 items-center">
      <Badge
        v-for="tag in initialState"
        :key="tag.id"
        type="light"
        color="blue"
        :icon="!readonly ? 'close' : false"
        :label="tag.name"
        @remove="
          $emit(
            'update',
            initialState.filter((t) => t.id !== tag.id)
          )
        "
      />
      <TagsSelectModal
        v-if="!readonly"
        :key="initialState.length"
        :variant="variant"
        :title="title"
        :description="description"
        :initialState="initialState"
        :buildingIds="buildingIds"
        @update="$emit('update', $event)"
      >
        <Badge
          type="modern"
          border="dashed"
          :label="badgeAddLabel"
          :icon="badgeAddLabel ? undefined : 'only'"
          class="cursor-pointer"
        >
          <Icon name="plus" size="xs" />
        </Badge>
      </TagsSelectModal>
    </div>
  </div>
</template>

<script setup>
import { Badge } from "@/SharedComponents/Badges";
import { Icon } from "@/SharedComponents/Icon";
import { TagsSelectModal } from "@/SharedComponents/Modals";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["update"]);

defineProps({
  variant: { type: String, required: false },
  title: { type: String, required: true },
  badgeAddLabel: { type: String, required: false },
  description: { type: String, required: true },
  initialState: { type: Array, default: () => [] },
  readonly: { type: Boolean, required: false },
  buildingIds: { type: Array, required: false },
  displayTitle: { type: Boolean, required: false, default: () => true },
});
</script>
